export interface DateRangeOptions {
  minRef?: string;
  maxRef?: string;
  maxDays?: number;
}

export const dateRangeExtension = {
  type: 'date',
  base: undefined,
  messages: {
    'date.range': '{{#label}} exceeds allowed range (min={{#min}}, diffDays={{#diffDays}}, maxDays={{#maxDays}})',
  },
  rules: {
    dateRange: {
      method(options: DateRangeOptions) {
        return (this as any).$_addRule({ name: 'dateRange', args: { options } });
      },
      validate(value: any, helpers: any, args: any) {
        const { minRef, maxDays } = args.options;
        const context = helpers.state.ancestors[0];

        if (!minRef || !context[minRef]) return value;
        if (!maxDays) return value;

        const minDate = new Date(context[minRef]);
        const currDate = new Date(value);

        if (isNaN(minDate.getTime()) || isNaN(currDate.getTime())) {
          return helpers.error('date.range', {
            min: 'Invalid Date',
            diffDays: NaN,
            maxDays,
          });
        }

        const diffMs = currDate.getTime() - minDate.getTime();
        const diffDays = diffMs / (1000 * 60 * 60 * 24);

        if (diffDays < 0 || diffDays > maxDays) {
          return helpers.error('date.range', {
            min: minDate.toISOString(),
            diffDays: Number(diffDays.toFixed(2)),
            maxDays,
          });
        }

        return value;
      },
    },
  },
};
